module.exports = __webpack_public_path__ + "media/images/flags/64/Abkhazia-ac062b0d83101d31c882875b0d05df56.png";